import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import AdminLayout from "./layout/AdminLayout";
import AdminDashboard from "./pages/AdminDashboard";
import Resellers from "./pages/ResellerPage";
import Login from "./pages/Login";
import ResellerPage from "./pages/ResellerPage";
import ClientManagementPage from "./pages/ClientManagementPage";

const AppRoutes = () => (
  <Router>
    <Routes>
      <Route path="/" element={<Login />} />
      <Route path="/login" element={<Login />} />
      <Route path="/dashboard" element={<AdminLayout><AdminDashboard /></AdminLayout>} />
      <Route path="/resellers" element={<AdminLayout><ResellerPage /></AdminLayout>} />
      <Route path="/clients" element={<AdminLayout><ClientManagementPage /></AdminLayout>} />
    </Routes>
  </Router>
);

export default AppRoutes;
